import { all } from 'redux-saga/effects';
import { holdingPageSagas } from './HoldingPage/holdingPageSagas';

export function* pagesSagas() {
  yield all([holdingPageSagas()]);
}
